import { render, staticRenderFns } from "./HolidaysManagement.vue?vue&type=template&id=1849be06&scoped=true"
import script from "./HolidaysManagement.vue?vue&type=script&lang=js"
export * from "./HolidaysManagement.vue?vue&type=script&lang=js"
import style0 from "./HolidaysManagement.vue?vue&type=style&index=0&id=1849be06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1849be06",
  null
  
)

export default component.exports